export default {
  estaCarregando: false,
  lista: [],
  parametros: '',
  filtros: {
    turma: null,
    livro: null
  }
}
